import { ReactNode } from 'react'

interface AddButtonProps {
  handleModalOpen?: () => void
  buttonStyle?: string
  iconClassName?: string
  children: React.ReactNode
  icon?: ReactNode
}

const IconButton: React.FC<AddButtonProps> = ({
  handleModalOpen,
  buttonStyle,
  children,
  icon,
  iconClassName,
}) => {
  return (
    <div
      className={`${buttonStyle} flex gap-3 p-2 rounded-lg h-18 items-center bg-gray-100 cursor-pointer`}
      onClick={handleModalOpen}
    >
      <div
        className={`bg-black flex items-center justify-center w-10 h-10 rounded-md ${iconClassName || ''}`}
      >
        {icon}
      </div>

      {children}
    </div>
  )
}

export default IconButton
